import { media, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { padding } from "./full.js";
const classNamePrefix = "umd-layout-background-quarter";
const psuedo = {
  content: '""',
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  width: "100%",
  zIndex: -1,
  [`@media (${media.queries.tablet.max})`]: {
    display: "none"
  },
  [`@media (${media.queries.desktop.min})`]: {
    width: `calc(75% + 80px)`
  }
};
function composeQuarter(options) {
  const { theme = "light" } = options || {};
  let backgroundColor;
  if (theme === "light") {
    backgroundColor = color.gray.lightest;
  } else {
    backgroundColor = color.gray.darker;
  }
  const className = `${classNamePrefix}-${theme}`;
  return objectWithClassName({
    position: "relative",
    ...padding,
    "&:before": {
      ...psuedo,
      backgroundColor
    },
    className: [
      className,
      /** @deprecated Use 'umd-layout-background-quarter-{theme}' instead */
      "umd-layout-background-quater-color"
    ]
  });
}
const light = composeQuarter({ theme: "light" });
const dark = composeQuarter({ theme: "dark" });
export {
  composeQuarter,
  dark,
  light
};
//# sourceMappingURL=quarter.js.map
